import React, {Component, Fragment} from 'react'
import style from './style.popup'

// COMPONENTS
import {DishIcon, LogoDs} from '../app-icon/Icons'
import cx from "classnames";
import {ButtonContained} from "../app-button/button";
import Spinner from "../spinner";



class AcceptTerm extends Component {
  state = {
    user: window.state.user,
    openModal: true,
    openSnakbar: false,
  }

  constructor(props) {
    super(props)
    this.state = {
      opened: 1,
    }
  }
  successDataForm = status => {
    if (status === 'ok') {

      // // Отправка события
      // window.dataLayer.push({'event': 'setupconversion'})

      this.timer = setTimeout(
        () =>
          this.setState({
            opened: false,
          }),
        50
      )

    }
  }

  handleCloseSnakbar = (event, reason) => {
    if (reason === 'clickaway') {
      return
    }
    this.setState({ openSnakbar: false })
  }

  handleSubmitForm = event => {
    event.preventDefault();

    this.setState({
      isFetching: true,
    })

    const url = '/profile/accept/terms'
    const values = new FormData(event.target);
    const options = values => ({
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-TOKEN': document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute('content'),
      },
      body: JSON.stringify(values),
    })

    const errors = response => {
      if (response.errors) {
        const arrErrors = [].concat(
          ...Object.values(response.errors).map(error => error)
        )

        arrErrors &&
          arrErrors.map(error =>
            this.props.enqueueSnackbar(error, {
              variant: 'error',
              preventDuplicate: true,
              autoHideDuration: 6000,
            })
          )
      }

      this.setState({
        isFetching: false,
      })
    }

    function handleResponseFrom(response) {
      return response.json().then(res => {
        if (response.status >= 200 && response.status < 300) {
          return res
        } else {
          throw res
        }
      })
    }

    fetch(url, options(values))
      .then(handleResponseFrom)
      .then(({ status }) => {
        this.successDataForm(status)
      })
      .catch(errors)
  }

  componentWillUnmount() {
    clearTimeout(this.timer)
  }

  render() {
    const { classes } = this.props
    const { openModal, openSnakbar, isFetching } = this.state
    const { user } = window.state

    return (
      <Fragment>
        {this.state.opened ? (
          <div className={classes.popup}>
            <div className={classes.wrapper}>
              <div className={classes.iconWrapper}>
                <div className={classes.icon}>
                  <LogoDs />
                </div>
              </div>
              <div className={classes.content}>
                <div className={classes.subTitle}>
                  {`Продолжая пользоваться сервисом, Вы принимаете условия `} <p  style={{textAlign: 'center'}}><a href='https://romi.center/docs/ru_terms.pdf' target='_blank'>{'"Пользовательского соглашения"'}</a></p>
                </div>
                <form
                  onSubmit={this.handleSubmitForm}
                  className={cx(
                    classes.form
                  )}
                  style={{
                    marginTop: '23px'
                  }}
                  ref={form => (this.form = form)}
                >

                  <ButtonContained
                    style={{
                      height: 64,
                      fontSize: 16,
                      width: '100%',
                      padding: 0,
                      fontWeight: 600,
                    }}
                    type="submit"
                    color="primary"
                    // onClick={() => this.handleClick(classes, submitFailed)}
                    text={
                      isFetching ? <Spinner stroke="#000000" /> : 'Принять'
                    }
                  />
                </form>
              </div>
            </div>
          </div>
        ) : (
          ''
        )}
      </Fragment>
    )
  }
}

export default style(AcceptTerm)
